export default __webpack_public_path__ + "assets/aaa66dc1a0b951fd864e10e924dc6adb.svg";